let multiSelectListener;
let originalMarginTop;
let originalParentPosition;
let originalScroolableElement;
let originalAcestralOverflow;
let originalWidth;
let originalPosition;
let originalZIndex;
let elClone;
let elRef;
let isOpen = false;

function getScrollTopCompensation(element) {
    if (element == null) {
      return null;
    }
    const computedStyle = getComputedStyle(element);
    const computedOverflow = computedStyle.overflow;
    originalAcestralOverflow = computedOverflow;
    //console.log('teste', element.scrollHeight, element.clientHeight)
    if (computedOverflow == 'auto' || computedOverflow == 'scroll') {
        originalScroolableElement = element;
        const top = element.scrollTop;
        const fixed = top-(2*top); 
        originalScroolableElement.style.overflow = 'hidden';
      return `${fixed}px`;
    } else {
      return getScrollTopCompensation(element.parentElement);
    }
  }

function elementOpen(el) {
    if(!!isOpen) return;
    const { offsetWidth } = el;
    if(!!!elClone) {
        elClone = el.cloneNode(true);
        elClone.style.visibility = 'hidden';
    }
    el.parentElement.style.position = 'relative';
    el.style.marginTop = getScrollTopCompensation(el.parentElement);
    el.style.width = `${offsetWidth}px`;
    el.style.position = 'fixed';
    el.style.zIndex = 9999;
    el.parentNode.insertBefore(elClone, el.nextSibling);
    isOpen = true;
}
function elementClose(el) {
    el.parentElement.style.position = originalParentPosition;
    el.style.marginTop = originalMarginTop
    el.style.position = originalPosition;
    el.style.width = originalWidth;
    el.style.zIndex = originalZIndex;
    if (!!elClone) {
        elClone.remove();
        elClone = undefined;
    }
    if(!!originalScroolableElement) {
        originalScroolableElement.style.overflow = originalAcestralOverflow;
    }
    isOpen = false;
}

function isOutsideElement(el, target, path) {
    return target != el && !path.includes(el)
}

const selectPop = (event) => {
    const elClassArray = Array.from(elRef.classList);
    const elIsOpen = elClassArray.includes('is-open');

    if (isOutsideElement(elRef, event.target, event.path) || !elIsOpen) {
        elementClose(elRef);
        return;
    }
    elementOpen(elRef);
}

const cancelarScroll = (event) => {
  if (isOpen && isOutsideElement(elRef, event.target, event.path)) {
    event.preventDefault();
    event.stopPropagation();
  }
}

export const selectOverflowDirective = {
    mounted: (el, binding, vnode, prevNode) => {
        console.log(binding, binding.value, binding.arg)
        if(binding.arg == "active" && !binding.value) return;
        console.log(binding)
        originalMarginTop = el.style.marginTop;
        originalParentPosition = el.parentElement.style.position;
        originalWidth = el.style.width;
        originalPosition = el.style.position;
        originalZIndex = el.style.zIndex;
        elRef = el;
        window.addEventListener('click', selectPop)

        document.addEventListener(
          'wheel',
          cancelarScroll,
          {passive: false}
        );
    },
    beforeUnmount: (el, binding, vnode, prevNode) => {
      window.removeEventListener('click', selectPop)
      document.removeEventListener(
        'wheel',
        cancelarScroll,
        {passive: false}
      );
    }
  };